// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.prog-btn{min-width:200px}button.prog-btn:disabled>.small-loader>div{border-color:#ccc;border-top-color:#f3f3f3}button.prog-btn.is-loading{pointer-events:none}", ""]);
// Exports
module.exports = exports;
